import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	dropdown: {
		width: 190,
	},
});
